import Colors from '../../../config/colors';
const topSignSmallStyles = {
    signStyles:{
      width:"100%",
      backgroundColor:Colors.dkgreen,
      opacity:"1",
      position:"relative",
      height:"82px",
      border:"10px solid #fff",
      padding:"16px", 
      boxSizing:"border-box",
      textAlign:"center",
    },
    liStyle:{
      display: "inline",
      terSpacing: ".02em",
      cursor: "pointer",
      fontSize: "23px",
      textTransform: "initial",
      color:"#fff",
      opacity:1,
      padding:"0 16px",
      width:"33%",
      borderRight:"1px solid #fff",
    },
    liStyleRight:{
      display: "inline",
      terSpacing: ".02em",
      cursor: "pointer",
      fontSize: "23px",
      textTransform: "initial",
      color:"#fff",
      opacity:1,
      padding:"0 16px",
      width:"33%",
    },
    ulStyle:{
      listStyle:"none",
      position:"absolute",
      top:"0",
      left:"0",
      width:"100%",
      padding:"0px",
    },
    linkStyle:{
      textDecoration: "none",
      color: "#fff",
      fontFamily: "Oswald",
      textTransform: "uppercase",
      fontWeight: "400",
      lineHeight:"1em",
      wordBreak:"break-word",
  },
}

export default topSignSmallStyles;
